export function listenForNonceUpdates() {
  const channel = new BroadcastChannel("breakdance");
  channel.onmessage = function (message) {
    if (message.data.event === "nonceRefresh") {
      window.Breakdance.ajaxnonce = message.data.nonce;
    }
  };

  return channel;
}
